export enum Access {
	DIA = '226530000',
	BIA = '226530001',
	IP_TRANSIT = '226530002',
}
